module.exports = __webpack_public_path__ + "img/logo.d4cc0bea.png";